import * as TabsPrimitive from "@radix-ui/react-tabs";

const Tabs = TabsPrimitive.Root;
const TabList = TabsPrimitive.List;
const TabTrigger = TabsPrimitive.Trigger;
const TabContent = TabsPrimitive.Content;

export { Tabs, TabList, TabTrigger, TabContent };
